<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">Acknowledgements</p>
<p class="hang">To all the great people at The History Press, especially my acquisitions editor, Laurie Krill.</p>
<p class="hang">To Karyn Zoldan, friend and editor, for keeping this book tight.</p>
<p class="hang">Greg Casadei from the original Mama Louisa’s.</p>
<p class="hang">Michael and Suzanne Elefante from Mama Louisa’s, for all the info and photos and for answering my unending questions.</p>
<p class="hang">Sal Zagona Sr., Sal Zagona Jr. and Ande Motzkin from Caruso’s, for the stories, the company and the ravioli.</p>
<p class="hang">Rebecca Ramey and Janet Seidler from the Blue Willow, live and on the phone.</p>
<p class="hang">Dr. Jonathan Mabry, City of Tucson Historic Preservation Officer, Planning and Development Services, for his help making sure I got things right and for help with images.</p>
<p class="hang">Carlotta Flores, for her stories of her great Tia Monica and El Charro Café.</p>
<p class="hang">Gerald Gay, for his intrepid detective work, photos and connections.</p>
<p class="hang">Dr. Theresa Levy, my Italian teacher and friend, for her translation help.</p>
<p class="hang">A.J. Flick, for her keen eye.</p>
<p class="hang">Kelli and Will Phillips, for the beautiful photos of and information about her grandparents, Gus and Kay Balon.</p>
<p class="hang">Scott Barker, for his rapid response.</p>
<p class="hang">Clyde Buzzard, for the photos and history from Lucky Wishbone and Mark Morris, the next generation of Lucky Wishbone.</p>
<p class="hang">Dale Calvert, Sherry Baran, Jim Campbell, Kade Mislinski and Dave Musso from Saguaro Corners.</p>
<p class="hang">Gina Yturralde from Pat’s Drive In.</p>
<p class="hang">Teresa Shaar from El Minuto.</p>
<p class="hang">Yahtin and Naval Parekh from New Delhi Palace, for the lesson on Indian food and for your fabulous food.</p>
<p class="hang">Gordon Berger of Le Rendez-vous.</p>
<p class="hang">Susan Frank, for her numerous connections.</p>
<p class="hang">Dom Scala and Ed Irving, for all those eegee’s insights.</p>
<p class="hang">Boyd Bartke from Robert’s.</p>
<p class="hang">Aracely Gonzalez from Crossroads, for the shared information and her delicious dish.</p>
<p class="hang">Suzana Davila from Café Poca Cosa.</p>
<p class="hang">Jonathan Landeen from Jonathan’s Cork.</p>
<p class="hang">Dave Hoffman and Connie Gilbert from Li’l Abner’s.</p>
<p class="hang">Jimmy Lopez and the folks at “my little nest,” Mi Nidito.</p>
<p class="hang">Dan Bates and Casey Wills from Pinnacle Peak, for their time and the beautiful menus.</p>
<p class="hang">Shana and Richard Oseran, for taking time from their vacation to talk about the Cup.</p>
<p class="hang">The Arizona Inn, for the photos.</p>
<p class="hang">Darryl Wong of Lotus Garden.</p>
<p class="hang">Michael Suarez, for the Lucky Wishbone clothing.</p>
<p class="hang">My Facebook friends, who, whenever I asked for their memories of certain restaurants, answered my pleas. (That’s you, Marguerite Brown.)</p>
<p class="hang">My foodie friends Edie Jarolim, Norma Gentry, Matt Russell, Andi Berlin and Adam Lehrman, for their support and suggestions and the sharing of numerous dishes and drinks.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?38394aeb